import { useEffect, useRef } from 'react';

/**
 * Custom hook to track if a component is mounted. PLEASE NOTE: This returns
 * a ref object with a `current` property, not a boolean value.
 */
export const useIsMounted = () => {
  const isMounted = useRef(false);

  useEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);

  return isMounted;
};
